// 将一些变量注入到vue实例中
import Vue from 'vue';
import api from '@services';
import adApi from '@services/ad';
import toast from '@components/Toast';
import '@components/Toast/index.scss';
import * as filters from '@assets/js/filters';
import VueLazyload from 'vue-lazyload';
import { checkIsMobile } from '@assets/js/utils';

// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.$api = api;
Vue.prototype.$adApi = adApi;
Vue.use(toast, {
  pos: 'center', // toast位置
  duration: '3000', // 持续时间,s
  wordWrap: checkIsMobile() // 移动端换行，pc 不换行
});

Vue.use(VueLazyload, {
  // 使用了v-lazyload的src无法使用vue的filters
  filter: {
    progressive(listener) {
      listener.src = filters.overHTTPS(listener.src);
    },
    webp(listener, options) {
      if (!options.supportWebp) return;
      const isCDN = /esx.bigo.sg|static-web.bigolive.tv/;
      if (isCDN.test(listener.src)) {
        listener.src += listener.src.includes('?')
          ? '&resize=21&dw=0'
          : '?resize=21&dw=0';
      }
      // 封禁处理
      if (window.location.origin.includes('bigoapp.tv')) {
        listener.src = listener.src
          .replace('esx.bigo.sg', 'esx.piojm.tech')
          .replace('imgsnap.bigo.sg', 'imgsnap.piojm.tech');
      }
    }
  },
  loading:
    'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/loading-bg2.png'
});

export default (ctx) => {
  ctx.$isMobile = checkIsMobile(ctx?.req?.headers);
  Vue.prototype.$isMobile = ctx.$isMobile;
};
